import { MIDIOutputBox } from "@opendaw/studio-boxes";
import { asInstanceOf } from "@opendaw/lib-std";
import { AudioBusBoxAdapter } from "./audio-unit/AudioBusBoxAdapter";
import { Pointers } from "@opendaw/studio-enums";
import { IndexedBoxAdapterCollection } from "./IndexedBoxAdapterCollection";
import { AudioUnitBoxAdapter } from "./audio-unit/AudioUnitBoxAdapter";
import { BoxAdapterCollection } from "./BoxAdapterCollection";
import { TimelineBoxAdapter } from "./timeline/TimelineBoxAdapter";
import { GrooveShuffleBoxAdapter } from "./grooves/GrooveShuffleBoxAdapter";
import { PianoModeAdapter } from "./PianoModeAdapter";
export class RootBoxAdapter {
    #context;
    #box;
    #audioUnits;
    #audioBusses;
    #pianoMode;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#audioUnits = IndexedBoxAdapterCollection.create(this.#box.audioUnits, box => this.#context.boxAdapters.adapterFor(box, AudioUnitBoxAdapter), Pointers.AudioUnits);
        this.#audioBusses = new BoxAdapterCollection(this.#box.audioBusses.pointerHub, box => this.#context.boxAdapters.adapterFor(box, AudioBusBoxAdapter), Pointers.AudioBusses);
        this.#pianoMode = new PianoModeAdapter(this.#box.pianoMode);
    }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get box() { return this.#box; }
    get audioBusses() { return this.#audioBusses; }
    get audioUnits() { return this.#audioUnits; }
    get clips() {
        return this.#audioUnits.adapters()
            .flatMap(adapter => adapter.tracks.collection.adapters())
            .flatMap(track => track.clips.collection.adapters());
    }
    get groove() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.groove.targetVertex.unwrap("no groove").box, GrooveShuffleBoxAdapter);
    }
    get timeline() {
        return this.#context.boxAdapters
            .adapterFor(this.#box.timeline.targetVertex.unwrap("no timeline").box, TimelineBoxAdapter);
    }
    get pianoMode() { return this.#pianoMode; }
    get created() { return new Date(this.#box.created.getValue()); }
    get midiOutputDevices() {
        return this.#box.outputMidiDevices.pointerHub.incoming().map(({ box }) => asInstanceOf(box, MIDIOutputBox));
    }
    terminate() { this.#audioUnits.terminate(); }
}
